import React, { useState } from 'react'
import { FlightTrip } from '../../../assests/ExportImageIcon'
import BusFilterSidebar from '../../../componants/sidebar/busFilterSidebar'
// import FlightDateTabs from './FlightDateTabs'
import BusResults from './BusResults'

// This page is a static placeholder — no bus search API exists yet, so the search
// bar, sort tabs and results below are all hardcoded to match the reference design
// (see bus.jsx / busFilterSidebar.jsx / BusResults.jsx for the same approach).
//
// Full functional version (flight-search-style, wired to real results/filters) —
// kept for when a bus API exists.
//
// import { useEffect, useMemo } from 'react'
// import { useSelector } from 'react-redux'
// import FlightResults from './FlightResults'
// import FlightSearchLoader from '../../../componants/flightSearchLoader/FlightSearchLoader'
// import FilterSidebar from '../../../componants/sidebar/filterSidebar'
// import { applyFlightFilters, buildFilterOptions, defaultFilters } from './flightFilterUtils'
//
// Inside FindBus, in place of the static pieces below:
//     const results = useSelector((state) => state.flightSearch.results)
//     const searchParams = useSelector((state) => state.flightSearch.searchParams)
//     const isSearching = useSelector((state) => state.flightSearch.isSearching)
//
//     const rawFlights = useMemo(() => results?.flights || [], [results])
//     const filterOptions = useMemo(() => buildFilterOptions(rawFlights), [rawFlights])
//     const [filters, setFilters] = useState(() => defaultFilters(filterOptions))
//
//     useEffect(() => {
//         setFilters(defaultFilters(filterOptions))
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [results?.tui])
//
//     const filteredFlights = useMemo(() => applyFlightFilters(rawFlights, filters), [rawFlights, filters])
//
//     const countLabel = rawFlights.length && filteredFlights.length !== rawFlights.length
//         ? `${filteredFlights.length} of ${rawFlights.length} Flights`
//         : (results?.search_summary?.results_count_label || '0 Flights Available')
//
//     const fromLabel = searchParams.fromAirport
//         ? `${searchParams.fromAirport.code} - ${searchParams.fromAirport.city}`
//         : ''
//     const toLabel = searchParams.toAirport
//         ? `${searchParams.toAirport.code} - ${searchParams.toAirport.city}`
//         : ''
//
//     <FilterSidebar options={filterOptions} filters={filters} onChange={setFilters}
//         onReset={() => setFilters(defaultFilters(filterOptions))}
//         fromCity={searchParams.fromAirport?.city} toCity={searchParams.toAirport?.city} />
//     {isSearching ? <FlightSearchLoader /> : <FlightResults sortBy={sortBy} flights={filteredFlights} hasRawResults={rawFlights.length > 0} />}

const SORT_TABS = [
    { key: 'price', label: 'Price', subtext: 'Low to High' },
    { key: 'fastest', label: 'Fastest', subtext: 'Shortest First' },
    { key: 'departure', label: 'Departure', subtext: 'Earliest First' },
    { key: 'smart', label: 'Smart', subtext: 'Recommendation' },
]

const FindBus = () => {
    const [sortBy, setSortBy] = useState(null)

    return (
        <>
            <section className='allSearchArea commonTopPadding'>
                <div className='container'>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            {/* Static search summary bar — no bus API yet, so values are hardcoded
                                to match the reference design exactly instead of reading searchParams. */}
                            <div className='innerSearch bgWhite paddingCommon20 borderRadius20'>
                                <div className='innerSearchBar'>
                                    <div className='innerSearchField'>
                                        <label>From</label>
                                        <input type="text" value='BBI - Bhubaneswar' readOnly />
                                    </div>
                                    <div className='innerSwapIcon'>
                                        <img src={FlightTrip} alt="Swap" />
                                    </div>
                                    <div className='innerSearchField'>
                                        <label>To</label>
                                        <input type="text" value='DEL - New Delhi' readOnly />
                                    </div>
                                    <div className='innerSearchField'>
                                        <label>Departure</label>
                                        <input type="text" value='Fri, 19 Jun' readOnly />
                                    </div>
                                    <button type="button" className='innerSearchBtn'>
                                        Search
                                        <span>&#8250;</span>
                                    </button>
                                </div>

                                {/* Special Fares — not part of the reference design, commented out.
                                <div className='specialFares'>
                                    <span className='specialFaresLabel'>Special Fares <span className='optional'>(Optional)</span> :</span>
                                    {searchParams.studentFare && <div className='specialFarePill'>Student</div>}
                                    {searchParams.seniorCitizen && <div className='specialFarePill'>Senior Citizen</div>}
                                    {searchParams.armedForces && <div className='specialFarePill'>Armed Forces</div>}
                                </div>
                                */}
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className='searchListing'>
                                <div className='filterBar'>
                                    <BusFilterSidebar />
                                </div>
                                <div className='searchResult'>
                                    <div className='topTabFlightDate'>
                                        {/* Static/hardcoded dates & prices, not wired to real search — commented out until backend integration */}
                                        {/* <FlightDateTabs /> */}

                                        <div className='sortingCount'>
                                            <small>Sort by </small>
                                            <small>65 Buses Available</small>
                                        </div>

                                        <div className='filterTabs'>
                                            {SORT_TABS.map((tab) => (
                                                <div
                                                    key={tab.key}
                                                    className={`filterTab ${sortBy === tab.key ? 'active' : ''}`}
                                                    onClick={() => setSortBy(sortBy === tab.key ? null : tab.key)}
                                                >
                                                    <div className='filterTab__label'>{tab.label}</div>
                                                    <div className='filterTab__subtext'>{tab.subtext}</div>
                                                </div>
                                            ))}
                                        </div>

                                        <div className='resultFlight'>
                                            <BusResults />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </section>
        </>
    )
}

export default FindBus
